import { ErrorKey } from '@/router/model';
import { RouteRecordRaw, createRouter, createWebHistory } from 'vue-router';
import AppConfigStore from '@/stores/config/app-config-module';
import ErrorPage from '@/views/ErrorPage.vue';
import StationView from '@/views/StationView.vue';
import RasterView from '@/views/RasterView.vue';

const routes: RouteRecordRaw[] = [
  {
    path: '/error',
    component: ErrorPage,
    name: 'Error',
    props: (route) => ({ errorKey: route.query.key }),
  },
  {
    path: '/station/:mode/:resourceId',
    component: StationView,
    props: (route) => ({
      type: 'station',
      mode: route.params.mode,
      resourceId: route.params.resourceId,
    }),
  },
  {
    path: '/raster/:mode/:resourceId',
    component: RasterView,
    props: (route) => ({
      query: route.query,
      mode: route.params.mode,
      resourceId: route.params.resourceId,
    }),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// guard that checks successful config loading
router.beforeEach((to, _, next) => {
  if (to.name === null) {
    next({ name: 'Error', query: { key: ErrorKey.UNKNOWN_PATH } });
  }
  if (to.name !== 'Error' && !AppConfigStore.hasLoaded) {
    next({ name: 'Error', query: { key: ErrorKey.CONFIG_LOADING } });
  } else {
    next();
  }
});

router.afterEach(() => {
  if (!document.getElementById('plausible-script')) {
    const domain = AppConfigStore.plausibleDataDomain || '';
    const script = document.createElement('script');
    script.defer = true;
    script.setAttribute('data-domain', domain);
    script.src = 'https://plausible.hub-infra.geosphere.at/js/script.js';
    script.id = 'plausible-script';
    document.head.appendChild(script);
  }
});

export default router;

export function goToErrorPage(errorKey: ErrorKey): void {
  router.replace({ name: 'Error', query: { key: errorKey } });
}
